import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "SearchModule",
    component: () => (__SERVER__ ? require("./search-module-view") : import("./search-module-view"))
});

export default definition;
